import Image from 'app/Components/Shared/Image/image';
import React, {useEffect} from 'react';
import BtnSubmit from '../../../../Shared/Buttons/BtnSubmit';
import {Button, Col, Row} from 'reactstrap';
import {connect} from 'react-redux';
import './CancelPackagePopUp.scss';
import {gaEvent} from '../../../../../utilities/analytics/tracking';
import gaParams from '../../../../../utilities/analytics/constants';
import {dwhRemoveAbroadAddon} from '../../dwhReports';
import {AbroadSocType} from '../../Shared/Models/AbroadPackageModels';
import {gaCancelAddonsStep2, gaCancelAddonPopup} from '../../../AbroadTicketBlock/gaReports';

const CancelAddonPackagePopUp = ({cancelPackage, onClose, dwhParams, socTitle}) => {
  useEffect(() => {
    gaCancelAddonPopup(socTitle);
    dwhRemoveAbroadAddon({message: 'Cancel PopUp Displayed', status: 'Ongoing', ...dwhParams});
  }, []);

  function goBack() {
    dwhRemoveAbroadAddon({message: 'Do Not Cancel Button Clicked', status: 'Ongoing', ...dwhParams});
    onClose();
  }

  const cancelAndClose = async () => {
    gaCancelAddonsStep2(socTitle);
    dwhRemoveAbroadAddon({message: 'Cancel Service Button Clicked', status: 'Completed', ...dwhParams});
    await cancelPackage();
  };

  return (
    <div className='cancel-Addon-pop-up-container'>
      <Image src={require('../images/info.svg')} />
      <div className='description'> בטוח שאתם רוצים להסיר את {socTitle}?</div>
      <div className='button-container'>
        <button className='white' onClick={() => goBack()}>
          לא, לחצתי בטעות
        </button>
        <button onClick={() => cancelAndClose()}>אני רוצה לבטל </button>
      </div>
    </div>
  );
};

const mapStateToProps = (state) => ({});

const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(CancelAddonPackagePopUp);
